// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3204":"6fb71152","3979":"0615d590","6423":"0615d590"}[chunkId] + ".chunk.css";
};